// src/App.jsx
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

import PanelAdministradorWrapper from './page/PanelAdministradorWrapper';
import PanelComercioWrapper from './page/PanelComercioWrapper';
import Kiosco from './page/Kiosco';
import Info from './page/Info';
import PWACliente from './page/PWACliente';
// import Landing from './page/Landing';

function App() {
  return (
    <Router>
      <Routes>
        {/* 🔀 Redirigir raíz a /info */}
        <Route path="/" element={<Navigate to="/info" replace />} />

        {/* ℹ️ Información pública */}
        <Route path="/info" element={<Info />} />

        {/* 🔐 Administración */}
        <Route path="/panel" element={<PanelAdministradorWrapper />} />

        {/* 🏬 Comercios */}
        <Route path="/panel-comercio" element={<PanelComercioWrapper />} />

        {/* 🛒 Kiosco (con login propio) */}
        <Route path="/kiosco" element={<Kiosco />} />

        {/* 🧑‍💻 Clientes */}
        <Route path="/PWACliente" element={<PWACliente />} />

        {/* 🚫 Landing deshabilitada para producción */}
        {/* <Route path="/landing" element={<Landing />} /> */}
      </Routes>
    </Router>
  );
}

export default App;


